export interface WelfareInitiative {
  id: string;
  title: string;
  region: string;
  description: string;
  photoUrl: string;
  photoAlt: string;
  photoCredit: string;
  quote?: { text: string; attribution: string };
  // Company-wide, quantified "measurable impact" figure (e.g. "120 families
  // supported"). Left undefined on every entry — see the module comment
  // below for why.
  impactStat?: { label: string; value: string };
  harbourId?: string; // cross-links into operations.ts's HARBOURS[].id
}

// impactStat is deliberately left undefined on every entry below. The AC
// frames it as a company-wide, audited program total ("120 fishermen
// families supported") — structurally the same class of claim as
// caseStudies.ts's rejected "35% reduction in spoilage," not the same as
// testimonials.ts's individual composite-persona stat (one person's own
// self-reported experience woven into a first-person quote). No real
// program-wide total exists yet to report. The initiative *narrative*
// (description, real credited photo) stays in this project's established
// generic-brand-copy register and ships as real content — only the numeric
// aggregate is withheld until there's a real one to report.
export const WELFARE_INITIATIVES: WelfareInitiative[] = [
  {
    id: "fair-price-guarantee",
    title: "The Fair-Price Guarantee",
    region: "Malabar Coast",
    description:
      "Partner crews are paid a pre-agreed floor price for their catch, set above the going wholesale rate and reviewed each season — regardless of how the day's market swings. It means a slow morning at the dock doesn't turn into a bad week at home.",
    photoUrl:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Fishing_boats_in_Kerala%2C_India.jpg/960px-Fishing_boats_in_Kerala%2C_India.jpg",
    photoAlt: "Wooden fishing boats moored along the Kerala coast",
    photoCredit: "Josephgeorge23 / Wikimedia Commons, CC BY-SA 4.0",
    harbourId: "harbour-malabar",
  },
  {
    id: "monsoon-support-fund",
    title: "Monsoon Support Fund",
    region: "Coromandel Coast",
    description:
      "During the annual trawling ban, when boats stay ashore for weeks at a stretch, partner families can draw on a small standing fund built from a share of each order — a bridge, not a bonus, meant to get a household through to the next season without a gap in income.",
    photoUrl:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/26/Weighing_fish_baskets_in_Rameswar_fishing_port..JPG/960px-Weighing_fish_baskets_in_Rameswar_fishing_port..JPG",
    photoAlt: "Fishermen weighing baskets of the day's catch at a Tamil Nadu fishing port",
    photoCredit: "Rudolph.A.furtado / Wikimedia Commons, CC0",
    harbourId: "harbour-coromandel",
  },
];
